export default __webpack_public_path__ + "static/media/ANJ.png.df66501e.png";